import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import MUISnackbar from '@material-ui/core/Snackbar';

@inject('viewStore')
@observer
// Shows material ui snackbars
class Snackbar extends Component {
  render() {
    const { viewStore } = this.props;

    return (
      <MUISnackbar
        open={viewStore.snackbarOpen}
        message={viewStore.snackbarMessage}
        onClose={viewStore.hideSnackbar}
        autoHideDuration={6000}
      />
    );
  }
}

export default Snackbar;
